<template>
  <div>
    <div class="row">
      <!-- Left Section (Sidebar) -->
      <div class="col-md-3 bg-light border-right">
        <h4>Create Listings</h4>
        <div>
          <!-- Modal for adding a new record -->
        <b-modal v-model="showModal" title="Create Event Listings">
          <b-form>
            <b-form-group label="Venue" label-for="Venue">
              <b-form-input
                id="newSection"
                v-model="selectedVenue"
                required
              ></b-form-input>
            </b-form-group>
          </b-form>
        </b-modal>
          <!-- Searchable Dropdown -->
          <b-form-group label="Search and Select an Option:">
            <div class="search-container">
              <b-form-input
                v-model="search"
                placeholder="Type to search"
                @keypress="handleKeyPress"
                class="mb-2"
                ref="searchInput"
              ></b-form-input>
              <span v-if="isLoadingVenues" class="spinner"></span>
            </div>
            <b-form-select
              id="input-venue"
              v-model="selectedOption"
              :options="[{ value: null, text: 'Select a venue' }, ...search_options]"
              @change="fetchSBEvents"
              required
              class="custom-select"
            ></b-form-select>
          </b-form-group>

          <!-- Display the selected option -->
          <div v-if="selectedOption" class="mt-2">
            <!-- <strong>Selected Venue: </strong> {{ selectedOption }} <br/>
            <strong>Selected Event(s):</strong> {{ selectedEvents }} <br/> -->
            <!-- <b-button variant="primary" :disabled="selectedEvents.length == 0" @click="toggleComponent">Choose Lots</b-button> -->
            <b-button variant="primary" :disabled="selectedEvents.length == 0" @click="toggleComponent">Create Listings</b-button>
          </div>
        </div>
      </div>
      
      <!-- Main Section -->
      <div class="col-md-9">
        <div v-if="ShowSelectEvent"> 
          <h4>Event Information</h4>
          <vue-good-table
            :columns="columns"
            :rows="eventData"
            :select-options="{ enabled: true, selectOnCheckboxOnly: true, selectAllByGroup: true }"
            :search-options="{ enabled: true }"
            :group-options="{
                enabled: true,
                collapsable: true,
                headerPosition: 'top'}"
            :pagination-options="{ mode: 'Pages', enabled: true, perPage: 100 }"
            @on-selected-rows-change="onSelectionChanged"
          >
            <!-- <template slot="selected-row-actions">
              <b-button variant="primary" @click="toggleComponent">Choose Lots</b-button>
            </template> -->
          </vue-good-table>
        </div>
        <div v-if="ShowSelectLot">
          <!-- <LotResults :items="selectedEvents"/> -->
          <ListingCreator 
            :selectedEvents=this.selectedEvents.toString()
            @error="handleError"
            @complete="handleComplete"
            @reset-events="resetSelectedEvents"
            @hide-listing-creator="toggleComponent"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { VueGoodTable } from 'vue-good-table';
import 'vue-good-table/dist/vue-good-table.css'
// import LotResults from './LotResults.vue';
import ListingCreator from './ListingCreator.vue';

export default {
  name: 'Listing-Form',
  components: {
    VueGoodTable,
    ListingCreator
    // LotResults
  },
  data() {
    return {
      columns: [
        {
          label: 'Event Name',
          field: 'name',
        },
        {
          label: 'Date',
          field: 'date',
          // type: 'date',
          dateInputFormat: 'yyyy-MM-dd',
          dateOutputFormat: 'MMM do yyyy',
        },
        {
          label: 'Tickets Sold',
          field: 'mySoldTickets',
        },
        {
          label: 'Tickets Available',
          field: 'ticketCount',
        },
        // Add more columns as needed
      ],
      showModal: false,
      ShowSelectEvent: true,
      ShowSelectLot: false,
      search: "",
      selectedOption: null,
      search_options: [],
      eventData: [],
      selectedEvents: [],
      selectedVenue:"",
      isLoadingVenues: false
    }
  },
  methods: {
    handleError(error) {
      console.error('Error:', error)
    },
    handleComplete(result) {
      console.log('Complete:', result)
    },
    resetSelectedEvents() {
      this.selectedEvents = []
    },
    async fetchVenues() {
      try {
        const response = await this.$http.get('https://api.spotjockeys.com/api/venues');
        this.venues = response.data.map(item => ({
          value: item.pw_venue_id,
          text: item.name,
        }));
        console.log(this.venues)
      } catch (error) {
        console.error('Error fetching venues:', error);
      }
    },
    async fetchSBVenues(search_term) {
      this.isLoadingVenues = true;
      try {
        const response = await this.$http.get('https://api.spotjockeys.com/api/sb/venue?search_term=' + search_term);
        this.search_options = response.data.rows.map(item => ({
          value: item.id,
          text: item.name
        }));
        if (this.search_options.length > 0) {
          this.selectedOption = this.search_options[0].value; // Automatically select the first result
        }
      } catch (error) {
        console.error('Error fetching venues:', error);
      } finally {
        this.isLoadingVenues = false;
      }
    },
    handleKeyPress(event) {
      if (event.key === "Enter") {
        this.fetchSBVenues(this.search);
      }
    },
    async fetchSBEvents() {
      let today = new Date().toISOString().split('T')[0]
      try {
        const response = await this.$http.get('https://api.spotjockeys.com/api/sb/events-grouped', {
          params: {
            'venueId': this.selectedOption,
            'eventDateFrom': today,
            'sortedBy': 'DATE'
          }
        });
        // this.eventData = response.data.rows;
        // console.log('EventData:', this.eventData)
        console.log(this.processGroupData(response.data))
      } catch (error) {
        console.error('Error fetching events:', error);
      }
    },
    toggleComponent() {
      this.ShowSelectEvent = !this.ShowSelectEvent;
      this.ShowSelectLot = !this.ShowSelectLot;
      // this.showModal = !this.showModal;
    },
    onSelectionChanged(params) {
      this.selectedEvents = params.selectedRows.map(row => row.id);
    },
    processGroupData(data) {
  try {
    // console.log(data);
    // Validate input
    if (!data || !data.rows || !Array.isArray(data.rows)) {
      throw new Error("Invalid JSON format. Expected 'rows' array.");
    }

    const groupedData = {};

    // Group data by "event name + date + venue name"
    data.rows.forEach(row => {
      // const eventName = row.name;
      // const venueName = row.venue.name;
      const eventDate = row.date;
      const date = new Date(eventDate);
      const yearDate = date.getFullYear();
      // const monthDate = String(date.getMonth() + 1).padStart(2, '0');
      const monthName = date.toLocaleString('default', { month: 'long' });
      const groupKey = `${yearDate}-${monthName}`;

      // Initialize group if it doesn't exist
      if (!groupedData[groupKey]) {
        groupedData[groupKey] = {
          mode: 'span',
          label: groupKey,
          html: true,
          // eventDate: new Date(eventDate), // Convert to Date for sorting
          children: [],
        };
      }

      // Add row to the corresponding group
      groupedData[groupKey].children.push(row);
      
    });

    // Convert grouped object into array format & sort by event date
    const formattedData = Object.values(groupedData)
      .sort((a, b) => a.eventDate - b.eventDate) // Sort by eventDate
      // .map(({ eventDate, ...rest }) => rest); // Remove eventDate before returning
    console.log(groupedData);
    // console.log(formattedData);
    this.eventData = formattedData;
  } catch (error) {
    throw new Error(`Error processing group data: ${error.message}`);
  }
}
  },
  mounted() {
    // You can initialize any data or fetch initial data here if needed
    this.$nextTick(() => {
    this.$refs.searchInput?.focus();
  });
  }
};
</script>

<style scoped>
.container-fluid {
  padding-top: 20px;
}

.border-right {
  border-right: 1px solid #ddd;
}

.custom-select {
  width: 100%;
  padding: 10px;
  border: 1px solid #e2e8f0;
  border-radius: 6px;
  font-weight: 400;
  line-height: 1.5;
  font-size: 1 rem;
  transition: border-color 0.2s;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, sans-serif;
}

.custom-select:focus {
  border-color: #4299e1;
  outline: none;
  box-shadow: 0 0 0 3px rgba(66, 153, 225, 0.1);
}

.search-container {
  position: relative;
}


</style>
